import { AuditLogsPage } from '@hq/sys-admin';
import { hq } from '../session';

/**
 * 审计日志（平台侧跨租户举证，门禁 sys:audit:view）。
 * 页面实现收敛在 `@hq/sys-admin`，本端开启租户维度与跨租户筛选。
 */
export default function AuditLogs() {
  return <AuditLogsPage platform hq={hq} />;
}
